import * as React from 'react';
import { Button, type ButtonProps } from './button.tsx';

export interface ActionButtonProps extends Omit<ButtonProps, 'size'> {
  /** Leading icon (decorative; provide aria-label when there is no text). */
  icon?: React.ReactNode;
}

/**
 * ActionButton — a quiet, compact desk action. A thin wrapper over Button that
 * fixes the small size and optionally prepends a leading icon.
 */
export const ActionButton = React.forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ icon, children, variant = 'secondary', ...props }, ref) => (
    <Button ref={ref} size="sm" variant={variant} {...props}>
      {icon}
      {children}
    </Button>
  ),
);
ActionButton.displayName = 'ActionButton';
